// Parse a breathing rhythm from a task description.
// Supports "4-4-4-4" (box), "4-7-8", "5-6-7", "5-5" and textual "4 secondi dentro, 6 fuori".
// Returns { inhale, hold1, exhale, hold2 } in seconds, or a sensible default.
const DEFAULT = { inhale: 5, hold1: 0, exhale: 5, hold2: 0 };
const ok = (n) => Number.isFinite(n) && n >= 2 && n <= 20;

export function parseBreathPattern(text = "") {
  const s = (text || "").toLowerCase();

  const seq = s.match(/(\d{1,2})\s*[-–:/xX]\s*(\d{1,2})(?:\s*[-–:/xX]\s*(\d{1,2}))?(?:\s*[-–:/xX]\s*(\d{1,2}))?/);
  if (seq) {
    const nums = seq.slice(1).filter((v) => v !== undefined).map(Number);
    if (nums.every(ok)) {
      if (nums.length === 2) return { inhale: nums[0], hold1: 0, exhale: nums[1], hold2: 0 };
      if (nums.length === 3) return { inhale: nums[0], hold1: nums[1], exhale: nums[2], hold2: 0 };
      if (nums.length === 4) return { inhale: nums[0], hold1: nums[1], exhale: nums[2], hold2: nums[3] };
    }
  }

  const inMatch = s.match(/(\d{1,2})\s*(?:second[io]|sec|s)?\s*(?:dentro|inspir|inhale)/);
  const outMatch = s.match(/(\d{1,2})\s*(?:second[io]|sec|s)?\s*(?:fuori|espir|exhale)/);
  if (inMatch || outMatch) {
    const inhale = inMatch && ok(Number(inMatch[1])) ? Number(inMatch[1]) : 5;
    const exhale = outMatch && ok(Number(outMatch[1])) ? Number(outMatch[1]) : inhale;
    return { inhale, hold1: 0, exhale, hold2: 0 };
  }

  return { ...DEFAULT };
}

export function rhythmLabel(p) {
  if (!p) return "5-5";
  return [p.inhale, p.hold1, p.exhale, p.hold2].filter((n) => n && n > 0).join("-");
}
